import { FbSVG, InstaSVG } from '../../assets/icons/icons'
import './Footer.css'
import { NavLink } from 'react-router-dom'



function Footer() {
    return(
        <footer className="footer">
            <div className="footer-container">
                {/* Company Info Section */}
                <div className="footer-section">
                    <div className="footer-logo">
                        <h3>SCPO GROUP INC</h3>
                        <p>Building lasting partnerships through innovative business solutions.</p>
                    </div>
                </div>

                {/* Quick Links Section */}
                <div className="footer-section">
                    <h4>Quick Links</h4>
                    <ul className="footer-links">
                        <li><NavLink to="/" onClick={() => window.scrollTo(0, 0)}>Home</NavLink></li>
                        <li><NavLink to="/services" onClick={() => window.scrollTo(0, 0)}>Services</NavLink></li>
                        <li><NavLink to="/about" onClick={() => window.scrollTo(0, 0)}>About Us</NavLink></li>
                        <li><NavLink to="/contact" onClick={() => window.scrollTo(0, 0)}>Contact</NavLink></li>
                    </ul>
                </div>

                {/* Contact Info Section */}
                <div className="footer-section">
                    <h4>Contact Info</h4>
                    <div className="contact-info">
                        <div className="contact-item">
                            <span className="contact-icon">📞</span>
                            <span>313 777-0707</span>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">✉️</span>
                            <span>Scpogroupinc@gmail.com</span>
                        </div>
                        <div className="contact-item">
                            <span className="contact-icon">📍</span>
                            <span>320 West Maple Str, Glendale, CA 91204</span>
                        </div>
                    </div>
                </div>

                {/* Social Media Section */}
                <div className="footer-section">
                    <h4>Follow Us</h4>
                    <div className="social-links">
                        <a href="https://www.facebook.com/profile.php?id=61582904572166&mibextid=wwXIfr&mibextid=wwXIfr" className="social-link" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
                            <span>
                                <FbSVG/>
                            </span>
                        </a>
                        <a href="https://www.instagram.com/scpo_group?igsh=NTc4MTIwNjQ2YQ%3D%3D&utm_source=qr" className="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
                            <span>
                                <InstaSVG/>
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="footer-bottom">
                <div className="footer-bottom-content">
                    <p>&copy; 2025 SCPO Group Inc. All rights reserved.</p>
                    <div className="footer-bottom-links">
                        <a href="#">Privacy Policy</a>
                        <a href="#">Terms of Service</a>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer